// test2628
(2628 && 0);
